import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Header from '@/components/Header'

import store from '@/store'

import { callControlRouters } from './callControl'
Vue.use(Router)

/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

const routes = [
    {
        path: '/Login',
        name: 'Login',
        component: Login,
        hidden: true
    },
    {
        path: '/Header',
        name: 'Header',
        component: Header,
        hidden: true
    },
    //菜单及首页
    {
        path: '/',
        component: resolve => require(['@/components/Index'], resolve),
        meta: {
            requireAuth: true
        },
        hidden: true,
        children: [
            // { 
            //     path: '/refresh', 
            //     component: resolve => require(['@/components/refresh'],resolve), 
            //     name: 'Refresh', 
            //     meta:{
            //         requireAuth: true
            //     },
            // },
            {
                path: '/',
                component: resolve => require(['@/components/Home'], resolve),
                name: 'Home',
                meta: {
                    requireAuth: true
                },
            },
            //我的案件--案件详情
            {
                path: '/CaseInfo/:caseId',
                component: resolve => require(['@/pages/Collectionmanage/CaseInfo'], resolve),
                name: 'CaseInfo',
                nametext: '案件详情',
                hidden: true,
                meta: {
                    requireAuth: true
                },
            },
            //非催收案件详情
            {
                path: '/CaseDetail/:caseId',
                component: resolve => require(['@/pages/CaseManage/CaseDetail'], resolve),
                name: 'CaseDetail',
                nametext: '案件详情',
                hidden: true,
                meta: {
                    requireAuth: true
                },
            },
        ]
    },
    //项目管理
    {
        path: '/',
        component: resolve => require(['@/components/Index'], resolve),
        name: '项目管理',
        meta: {
            requireAuth: true
        },
        hidden: true,
        children: [
            {
                path: '/ClientManage',
                component: resolve => require(['@/pages/ProjectManage/ClientManage'], resolve),
                name: '委托方管理',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/SetEditClient',
                component: resolve => require(['@/pages/ProjectManage/SetEditClient'], resolve),
                name: '设置模板',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/CaseImport',
                component: resolve => require(['@/pages/ProjectManage/CaseImport'], resolve),
                name: '案件导入',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/CommonTemplate',
                component: resolve => require(['@/pages/ProjectManage/CommonTemplate'], resolve),
                name: '常用模板',
                meta: {
                    requireAuth: true
                },
            },
        ]
    },
    //案件管理
    {
        path: '/',
        component: resolve => require(['@/components/Index'], resolve),
        name: '案件管理',
        meta: {
            requireAuth: true
        },
        hidden: true,
        children: [
            {
                path: '/CaseList',
                component: resolve => require(['@/pages/CaseManage/CaseList'], resolve),
                name: '案件分配',
                meta: {
                    requireAuth: true,
                    keepAlive: true
                },
            },
            {
                path: '/CaseList_Assign',
                component: resolve => require(['@/pages/CaseManage/CaseList_Assign'], resolve),
                name: '指定分案',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/CaseList_Rule',
                component: resolve => require(['@/pages/CaseManage/CaseList_Rule'], resolve),
                name: '规则分案',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/CaseApproval',
                component: resolve => require(['@/pages/CaseManage/CaseApproval'], resolve),
                name: '自有案件审批',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/CaseApprovalZC',
                component: resolve => require(['@/pages/CaseManage/CaseApprovalZC'], resolve),
                name: '资产案件审批',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/SnatchList',
                component: resolve => require(['@/pages/CaseManage/SnatchList'], resolve),
                name: '抢案池',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/SnatchManages',
                component: resolve => require(['@/pages/CaseManage/SnatchManages'], resolve),
                name: '抢案池管理',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/MonthCaseApply',
                component: resolve => require(['@/pages/CaseManage/MonthCaseApply'], resolve),
                name: '月度案件申请',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/MonthRecord',
                component: resolve => require(['@/pages/CaseManage/MonthRecord'], resolve),
                name: '月度申请记录',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/Detail',
                component: resolve => require(['@/pages/CaseManage/Detail'], resolve),
                name: 'Detail',
                nametext: '案件详情',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/Recycler',
                component: resolve => require(['@/pages/CaseManage/Recycler'], resolve),
                name: '回收站',
                meta: {
                    requireAuth: true
                },
            },
        ]
    },
    //诉讼管理
    {
        path: '/',
        component: resolve => require(['@/components/Index'], resolve),
        name: '诉讼管理',
        meta: {
            requireAuth: true
        },
        hidden: true,
        children: [
            {
                path: '/ElisorLaw',
                component: resolve => require(['@/pages/LawManage/ElisorLaw'], resolve),
                name: '司法诉讼',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/SelfLawList',
                component: resolve => require(['@/pages/LawManage/SelfLawList'], resolve),
                name: '自营诉讼列表',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/EntrustLawList',
                component: resolve => require(['@/pages/LawManage/EntrustLawList'], resolve),
                name: '委案诉讼列表',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/SelfLawVerify',
                component: resolve => require(['@/pages/LawManage/SelfLawVerify'], resolve),
                name: '自营诉讼审批',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/EntrustLawVerify',
                component: resolve => require(['@/pages/LawManage/EntrustLawVerify'], resolve),
                name: '委案诉讼审批',
                meta: {
                    requireAuth: true
                },
            },
        ]
    },
    //催收管理
    {
        path: '/',
        component: resolve => require(['@/components/Index'], resolve),
        name: '催收管理',
        meta: {
            requireAuth: true
        },
        hidden: true,
        children: [
            {
                path: '/MyCaseList',
                component: resolve => require(['@/pages/Collectionmanage/MyCaseList'], resolve),
                name: '我的案件',
                meta: {
                    requireAuth: true,
                    keepAlive: true,
                },
            },
            {
                path: '/MyPromise',
                component: resolve => require(['@/pages/Collectionmanage/MyPromise'], resolve),
                name: '我的承诺户',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/MyPayment',
                component: resolve => require(['@/pages/Collectionmanage/MyPayment'], resolve),
                name: '我的回款',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/MyApply',
                component: resolve => require(['@/pages/Collectionmanage/MyApply'], resolve),
                name: '我的申请',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/MyWorkOrder',
                component: resolve => require(['@/pages/Collectionmanage/MyWorkOrder'], resolve),
                name: '我的工单',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/MessageCentre',
                component: resolve => require(['@/pages/Collectionmanage/MessageCentre'], resolve),
                name: '消息中心',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/MessageDetail',
                component: resolve => require(['@/pages/Collectionmanage/MessageDetail'], resolve),
                name: '消息详情',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/MyLaws',
                component: resolve => require(['@/pages/Collectionmanage/MyLaws'], resolve),
                name: '我的诉讼',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/MyMark',
                component: resolve => require(['@/pages/Collectionmanage/MyMark'], resolve),
                name: '我的业绩',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/MyApp',
                component: resolve => require(['@/pages/Collectionmanage/MyApp'], resolve),
                name: '我的应用',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/Details',
                component: resolve => require(['@/pages/Collectionmanage/Detail'], resolve),
                name: '我的案件详情',
                meta: {
                    requireAuth: true
                },
            },
        ]
    },
    //协催管理
    {
        path: '/',
        component: resolve => require(['@/components/Index'], resolve),
        name: '协催管理',
        meta: {
            requireAuth: true
        },
        hidden: true,
        children: [
            {
                path: '/MyCouching',
                component: resolve => require(['@/pages/CouchingManage/MyCouching'], resolve),
                name: '我的协催',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/CouchingHandle',
                component: resolve => require(['@/pages/CouchingManage/CouchingHandle'], resolve),
                name: '协催处理',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/TeamCouching',
                component: resolve => require(['@/pages/CouchingManage/TeamCouching'], resolve),
                name: '团队协催',
                meta: {
                    requireAuth: true
                },
            },
        ]
    },
    //团队管理
    {
        path: '/',
        component: resolve => require(['@/components/Index'], resolve),
        name: '团队管理',
        meta: {
            requireAuth: true
        },
        hidden: true,
        children: [
            {
                path: '/TeamPay',
                component: resolve => require(['@/pages/TeamManage/TeamPay'], resolve),
                name: '团队回款',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/TeamCase',
                component: resolve => require(['@/pages/TeamManage/TeamCase'], resolve),
                name: '团队案件',
                meta: {
                    requireAuth: true,
                    keepAlive: true,
                },
            },
            { 
                path: '/TeamCase_Assign', 
                component: resolve => require(['@/pages/TeamManage/TeamCasePage/TeamCase_Assign'],resolve), 
                name: 'TeamCase_Assign', 
                meta:{
                    requireAuth: true
                },
            },
            { 
                path: '/TeamCase_Rule', 
                component: resolve => require(['@/pages/TeamManage/TeamCasePage/TeamCase_Rule'],resolve), 
                name: 'TeamCase_Rule', 
                meta:{
                    requireAuth: true
                },
            },
            {
                path: '/UserManage',
                component: resolve => require(['@/pages/TeamManage/UserManage'], resolve),
                name: '员工管理',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/TeamWorkManage',
                component: resolve => require(['@/pages/TeamManage/TeamWorkManage'], resolve),
                name: '团队工作管理',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/TeamLaws',
                component: resolve => require(['@/pages/TeamManage/TeamLaws'], resolve),
                name: '团队诉讼',
                meta: {
                    requireAuth: true
                },
            },
        ]
    },
    //指标管理
    {
        path: '/',
        component: resolve => require(['@/components/Index'], resolve),
        name: '指标管理',
        meta: {
            requireAuth: true
        },
        hidden: true,
        children: [
            {
                path: '/TeamTarget',
                component: resolve => require(['@/pages/TargetManage/TeamTarget'], resolve),
                name: '团队业绩指标',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/EntrustTarget',
                component: resolve => require(['@/pages/TargetManage/EntrustTarget'], resolve),
                name: '委托方指标',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/IndividualTarget',
                component: resolve => require(['@/pages/TargetManage/IndividualTarget'], resolve),
                name: '个人业绩指标',
                meta: {
                    requireAuth: true
                },
            },
        ]
    },
    //统计管理
    {
        path: '/',
        component: resolve => require(['@/components/Index'], resolve),
        name: '统计管理',
        meta: {
            requireAuth: true
        },
        hidden: true,
        children: [
            {
                path: '/TeamCallLog',
                component: resolve => require(['@/pages/StatisticsManage/TeamCallLog'], resolve),
                name: '团队通话',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/MyStatistics',
                component: resolve => require(['@/pages/StatisticsManage/MyStatistics'], resolve),
                name: '我的统计',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/MyStatisticsRecord',
                component: resolve => require(['@/pages/StatisticsManage/MyStatisticsRecord'], resolve),
                name: '统计记录',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/TeamLetters',
                component: resolve => require(['@/pages/StatisticsManage/TeamLetters'], resolve),
                name: '团队函件',
                meta: {
                    requireAuth: true
                },
            },
        ]
    },
    //智能协催
    {
        path: '/',
        component: resolve => require(['@/components/Index'], resolve),
        name: '智能协催',
        meta: {
            requireAuth: true
        },
        hidden: true,
        children: [
            {
                path: '/TaskList',
                component: resolve => require(['@/pages/AIAssist/TaskList'], resolve),
                name: '任务列表',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/PersonalPlan',
                component: resolve => require(['@/pages/AIAssist/PersonalPlan'], resolve),
                name: '个人计划',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/Returns/:taskId',
                component: resolve => require(['@/pages/AIAssist/Returns'], resolve),
                name: 'Returns',
                nametext: '查看报告',
                meta: {
                    requireAuth: true
                },
            },
        ]
    },
    //风控管理
    {
        path: '/',
        component: resolve => require(['@/components/Index'], resolve),
        name: '风控管理',
        meta: {
            requireAuth: true
        },
        hidden: true,
        children: [
            {
                path: '/RecordList',
                component: resolve => require(['@/pages/RiskManage/RecordList'], resolve),
                name: '录音列表',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/RecordListCopy',
                component: resolve => require(['@/pages/RiskManage/RecordListCopy'], resolve),
                name: '录音列表-1',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/RegisterList',
                component: resolve => require(['@/pages/RiskManage/RegisterList'], resolve),
                name: '登记列表',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/DownTask',
                component: resolve => require(['@/pages/RiskManage/DownTask'], resolve),
                name: '下载任务',
                meta: {
                    requireAuth: true
                },
            },
        ]
    },
    //财务管理
    {
        path: '/',
        component: resolve => require(['@/components/Index'], resolve),
        name: '财务管理',
        meta: {
            requireAuth: true
        },
        hidden: true,
        children: [
            {
                path: '/ApplicationStatistics',
                component: resolve => require(['@/pages/FinanceManage/ApplicationStatistics'], resolve),
                name: '应用结算统计',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/MyPaymentApproval',
                component: resolve => require(['@/pages/FinanceManage/MyPaymentApproval'], resolve),
                name: '自营回款审批',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/PartyAApproval',
                component: resolve => require(['@/pages/FinanceManage/PartyAApproval'], resolve),
                name: '甲方回款审批',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/EntrustPaymentApproval',
                component: resolve => require(['@/pages/FinanceManage/EntrustPaymentApproval'], resolve),
                name: '委案回款审批',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/CommissionSettlement',
                component: resolve => require(['@/pages/FinanceManage/CommissionSettlement'], resolve),
                name: '佣金结算',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/CommissionDetail',
                component: resolve => require(['@/pages/FinanceManage/CommissionDetail'], resolve),
                name: '佣金结算查询',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/SettleApp',
                component: resolve => require(['@/pages/FinanceManage/SettleApp'], resolve),
                name: '应用结算',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/SettleDetail',
                component: resolve => require(['@/pages/FinanceManage/SettleDetail'], resolve),
                name: '查看明细',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/SeatExpendDetail/:seatExId',
                component: resolve => require(['@/pages/FinanceManage/SettleDetail/SeatExpendDetail'], resolve),
                name: 'SeatExpendDetail',
                nametext: '坐席消费详情',
                meta: {
                    requireAuth: true
                },
            },
        ]
    },
    //呼叫控制台
    {
        path: '/',
        component: resolve => require(['@/components/Index'], resolve),
        name: '呼叫控制台',
        meta: {
            requireAuth: true
        },
        hidden: true,
        children: [
            {
                path: "/AIcall",
                component: resolve => require(['@/pages/CallCenter/AIcall'],resolve), 
                name: '智能外呼', 
                meta:{
                    requireAuth: true
                },
            },
            {
                path: '/AIvoiceDetail/:taskId',
                component: resolve => require(['@/pages/CallCenter/AIcallPage/AIvoiceDetail'], resolve),
                name: 'AIvoiceDetail',
                nametext: '查看结果',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: '/yccallDetail/:taskId',
                component: resolve => require(['@/pages/CallCenter/YccallPage/yccallDetail'], resolve),
                name: 'yccallDetail',
                nametext: '查看结果',
                meta: {
                    requireAuth: true
                },
            },
            {
                path: "/staffCall",
                component: resolve => require(['@/pages/CallCenter/staffCall'],resolve), 
                name: '员工通话分析', 
                meta:{
                    requireAuth: true
                },
            },
        ]
    },
    //系统设置
    {
        path: '/',
        component: resolve => require(['@/components/Index'],resolve), 
        name: '系统设置',
        meta:{
            requireAuth: true
        },
        hidden: true,
        children: [
            { 
                path: '/InstitutionSetting', 
                component: resolve => require(['@/pages/SystemSetup/InstitutionSetting'],resolve), 
                name: '机构设置', 
                meta:{
                    requireAuth: true
                },
            },
            { 
                path: '/RoleSetting', 
                component: resolve => require(['@/pages/SystemSetup/RoleSetting'],resolve), 
                name: '角色设置', 
                meta:{
                    requireAuth: true
                },
            },
            { 
                path: '/TelSetting', 
                component: resolve => require(['@/pages/SystemSetup/TelSetting'],resolve), 
                name: '坐席设置', 
                meta:{
                    requireAuth: true
                },
            },
            { 
                path: '/RecordSetting', 
                component: resolve => require(['@/pages/SystemSetup/RecordSetting'],resolve), 
                name: '备案设置', 
                meta:{
                    requireAuth: true
                },
            },
            { 
                path: '/WhiteSetting', 
                component: resolve => require(['@/pages/SystemSetup/WhiteSetting'],resolve), 
                name: '白名单设置', 
                meta:{
                    requireAuth: true
                },
            },
            { 
                path: '/RepaymentSetting', 
                component: resolve => require(['@/pages/SystemSetup/RepaymentSetting'],resolve), 
                name: '还款设置', 
                meta:{
                    requireAuth: true
                },
            },
            { 
                path: '/MemorySetting', 
                component: resolve => require(['@/pages/SystemSetup/MemorySetting'],resolve), 
                name: '催记设置', 
                meta:{
                    requireAuth: true
                },
            },
            { 
                path: '/QualitySetting', 
                component: resolve => require(['@/pages/SystemSetup/QualitySetting'],resolve), 
                name: '质检设置', 
                meta:{
                    requireAuth: true
                },
            },
            { 
                path: '/LetterSetting', 
                component: resolve => require(['@/pages/SystemSetup/LetterSetting'],resolve), 
                name: '发函设置', 
                meta:{
                    requireAuth: true
                },
            },
            { 
                path: '/MailboxSetting', 
                component: resolve => require(['@/pages/SystemSetup/MailboxSetting'],resolve), 
                name: '邮箱设置', 
                meta:{
                    requireAuth: true
                },
            },
            { 
                path: '/SafeSetting', 
                component: resolve => require(['@/pages/SystemSetup/SafeSetting'],resolve), 
                name: '安全设置', 
                meta:{
                    requireAuth: true
                },
                // redirect: '/SafeSetting/SetEncrypt',
                children: [
                    {
                        path: 'SetEncrypt',
                        name: '脱敏设置',
                        component: resolve => require(['@/pages/SystemSetup/SafeSet/SetEncrypt'],resolve),
                    },
                    {
                        path: 'SetWaterMark',
                        name: '水印设置',
                        component: resolve => require(['@/pages/SystemSetup/SafeSet/SetWaterMark'],resolve),
                    },
                    {
                        path: 'SetCopy',
                        name: '禁止复制页面信息',
                        component: resolve => require(['@/pages/SystemSetup/SafeSet/SetCopy'],resolve),
                    },
                    {
                        path: 'SetCaseTag',
                        name: '标签设置',
                        component: resolve => require(['@/pages/SystemSetup/SafeSet/SetCaseTag'],resolve),
                    },
                ]
            },
            { 
                path: '/LineInfomation', 
                component: resolve => require(['@/pages/SystemSetup/LineInfomation'],resolve), 
                name: '线路信息', 
                meta:{
                    requireAuth: true
                },
            },
        ]
    },
    //甲方管理
    {
        path: '/',
        component: resolve => require(['@/components/Index'],resolve), 
        name: '甲方管理',
        meta:{
            requireAuth: true
        },
        hidden: true,
        children: [
            { 
                path: '/MyPartyAPayment', 
                component: resolve => require(['@/pages/PartyAManage/MyPartyAPayment'],resolve), 
                name: '我的甲方回款', 
                meta:{
                    requireAuth: true
                },
            },
            { 
                path: '/TeamPartyAPayment', 
                component: resolve => require(['@/pages/PartyAManage/TeamPartyAPayment'],resolve), 
                name: '团队甲方回款', 
                meta:{
                    requireAuth: true
                },
            },
            { 
                path: '/PartyAEntrustSet', 
                component: resolve => require(['@/pages/PartyAManage/PartyAEntrustSet'],resolve), 
                name: '甲方委托方设置', 
                meta:{
                    requireAuth: true
                },
            },
        ]
    },
    //外访管理
    {
        path: '/',
        component: resolve => require(['@/components/Index'],resolve), 
        name: '外访管理',
        meta:{
            requireAuth: true
        },
        hidden: true,
        children: [
            { 
                path: '/MyOutbound', 
                component: resolve => require(['@/pages/OutboundVisit/MyOutbound'],resolve), 
                name: '我的外访', 
                meta:{
                    requireAuth: true
                },
            },
            { 
                path: '/TeamOutbound', 
                component: resolve => require(['@/pages/OutboundVisit/TeamOutbound'],resolve), 
                name: '团队外访', 
                meta:{
                    requireAuth: true
                },
            },
        ]
    },
    //决策分析系统
    {
        path: '/',
        component: resolve => require(['@/components/Index'],resolve), 
        name: '决策分析系统',
        meta:{
            requireAuth: true
        },
        hidden: true,
        children: [
            { 
                path: '/MyTeamMark', 
                component: resolve => require(['@/pages/PolicyAnalyse/MyTeamMark'],resolve), 
                name: '我的团队业绩', 
                meta:{
                    requireAuth: true
                },
            },
            { 
                path: '/TeamOverall', 
                component: resolve => require(['@/pages/PolicyAnalyse/TeamOverall'],resolve), 
                name: '团队整体情况', 
                meta:{
                    requireAuth: true
                },
            },
            { 
                path: '/ProductFollow', 
                component: resolve => require(['@/pages/PolicyAnalyse/ProductFollow'],resolve), 
                name: '产品跟踪', 
                meta:{
                    requireAuth: true
                },
            },
        ]
    },
    //实名三要素
    {
        path: '/RealName',
        name: '实名认证',
        hidden: true,
        component: resolve => require(['@/components/RealName'],resolve),
        meta:{
            requireAuth: true
        },
    },
    {
        path: '/RealSuccess',
        name: '实名认证成功',
        hidden: true,
        component: resolve => require(['@/components/RealSuccess'],resolve),
    },
    // //我的案件--案件详情
    // {
    //     path: '/CaseInfo', 
    //     component: resolve => require(['@/pages/Collectionmanage/CaseInfo'],resolve), 
    //     name: '我的案件信息', 
    //     hidden: true,
    //     meta:{
    //         requireAuth: true
    //     },
    // },
    // //非催收案件详情
    // { 
    //     path: '/CaseDetail', 
    //     component: resolve => require(['@/pages/CaseManage/CaseDetail'],resolve), 
    //     name: '非催收案件详情', 
    //     hidden: true,
    //     meta:{
    //         requireAuth: true
    //     },
    // },
    //404
    {
        path: '/404',
        name: '404Page',
        hidden: true,
        component: resolve => require(['@/components/404Page'],resolve),
    },
    //500
    {
        path: '/500',
        name: '500Page',
        component: resolve => require(['@/components/500Page'],resolve),
        hidden: true
    },
    //全局
    {
        path: '*',
        hidden: true,
        redirect: {
        	path: '/404'
        }
    } 
]

const all_routes = [...routes, ...callControlRouters];
const router = new Router({
	routes: all_routes,
	// mode: 'history'
})

//全局守卫

router.beforeEach((to, from, next) => {
    let token = JSON.parse(localStorage.getItem('token'));
    if (to.matched.some(record => record.meta.requireAuth)){  // 判断该路由是否需要登录权限
        if (token) {  // 判断当前的token是否存在
            let tags = store.getters.visitedViews;
            if (tags.length > 0 && to.path.indexOf('CaseInfo') > -1 && !to.query.switch) {
                for (let i = 0; i < tags.length; i++) {
                    const item = tags[i]
                    if (item.queryid == to.query.id) {
                        let query = to.query;
                        query.switch = 'tag'
                        // router.push({
                        //     path: item.path,
                        //     query: query
                        // })
                        next({
                            path: item.path,
                            query: query
                        })
                    } else {
                        next()
                    }
                }
            } else {
                next()
            }
            
        }else {
            next({
                path: '/Login',
                query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
            })
        }
    }else {
        next();
    }

    //已登录状态；当路由到login时，跳转至上一个页面
    if(to.fullPath == '/Login'){
        if(JSON.parse(localStorage.getItem('token'))){
            next({
                path: from.fullPath
            });
        }else{
            next();
        }
    }
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js